module.exports = __webpack_public_path__ + "static/Ranger - How to Connect a Read-Only Report-f9e3f8df68ebf6703cc1b5c06458449e.pdf";